export default "__VITE_ASSET__BEaWgj4P__"